export const ActivityFeedStatus = {
  Read: "read",
  UnRead: "unread",
  Removed: "removed",
};
